//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
import "../AME/AME.BasicPropertiesBuilder.js";
import "../AME/AME.ReferenceObjectBuilder.js";
import "../AME/AME.SortingBlockBuilder.js";
let d=[[[1,"BasicProperties",0,"AME.BasicPropertiesBuilder",0],[1,"ReferenceObject",0,"AME.ReferenceObjectBuilder",0],[1,"SortingBlock",0,"AME.SortingBlockBuilder",0]],[[[],"EstablishEvaluator",{R_:{expressionEvaluator:"AME.ExpressionEvaluator"}},0,0]],[]];
SPLM.AME.BaseEvaluatorBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.BaseEvaluatorBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.BaseEvaluatorBuilder.ContextType = Object.freeze({
    "Function" : "Function", "Location" : "Location", "Product" : "Product", "Automation" : "Automation"});

SPLM.AME.BaseEvaluatorBuilder.ConditionType = Object.freeze({
    "Contains" : "Contains", "Equals" : "Equals", "NotEquals" : "NotEquals", "LessThan" : "LessThan", "GreaterThan" : "GreaterThan", "LessThanEquals" : "LessThanEquals", "GreaterThanEquals" : "GreaterThanEquals"});

export default SPLM;